/**
 * Map tab — extracted from ClientDetail.jsx (Feb 2026).
 *
 * Read-only Google Maps preview of the venue, plus an "Open in Maps"
 * button. Gated behind the PRO plan via PlanLock.
 *
 * Contract:
 *   • client     — current client document.
 *   • patch      — single-field setter (used for the venue input).
 *   • mapsUrl    — pre-computed Google Maps URL for the venue.
 */
import React from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import PlanLock from "@/components/PlanLock";

export default function MapTab({ client, patch, mapsUrl }) {
  return (
    <PlanLock module="mappa" requiredPlan="pro" label="Mappa evento">
      <div className="bg-white border border-border rounded-sm p-8 space-y-6">
        <div>
          <h2 className="font-serif-heading text-2xl">Mappa evento</h2>
          <p className="text-sm text-neutral-500 mt-1">Indirizzo della cerimonia e apertura rapida su Google Maps.</p>
        </div>

        <div>
          <Label className="label-uppercase">Location</Label>
          <Input
            value={client.venue || ""}
            onChange={(e) => patch("venue", e.target.value)}
            className="mt-1 rounded-sm"
            placeholder="Es. Villa dei Cedri, Via Roma 12, Firenze"
            data-testid="map-venue-input"
          />
        </div>

        {client.venue ? (
          <div className="space-y-4">
            <div className="aspect-[16/9] w-full overflow-hidden rounded-sm border border-border bg-secondary">
              <iframe
                title="Mappa evento"
                src={`https://www.google.com/maps?q=${encodeURIComponent(client.venue)}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                data-testid="map-iframe"
              />
            </div>
            <a href={mapsUrl} target="_blank" rel="noopener noreferrer" data-testid="map-open-button">
              <Button className="rounded-sm">
                <ExternalLink className="w-4 h-4 mr-2" strokeWidth={1.5} /> Apri in Google Maps
              </Button>
            </a>
          </div>
        ) : (
          <div className="border border-dashed border-border rounded-sm p-12 text-center text-sm text-neutral-500">
            Aggiungi un indirizzo per visualizzare la mappa.
          </div>
        )}
      </div>
    </PlanLock>
  );
}
